import API from "@/utils/Api";
import { get } from "@/context/context";
import {AxiosResponse} from "axios";
import {LevelsRepository} from "@/repositories/LevelsRepository";
import {Level} from "@/models/Level";

export class LevelsApi implements LevelsRepository {

    private api: API = get('api');

    public async getLevels(): Promise<Level[]> {
        const response: AxiosResponse<Level[]> =
            await this.api.get('/uploader/wix/level');
        const { data } = response;
        return data || [];
    }

}
